import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common/ui";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UsersTab from "@/components/settings/UsersTab";
import RolesTab from "@/components/settings/RolesTab";
import FieldsTab from "@/components/settings/FieldsTab";
import ListsTab from "@/components/settings/ListsTab";
import DataTab from "@/components/settings/DataTab";
import AuditTab from "@/components/settings/AuditTab";

export default function Settings() {
  const { can } = useAuth();
  const tabs = [
    ["users", "Users", ["users.manage"], UsersTab],
    ["roles", "Roles & permissions", ["users.manage"], RolesTab],
    ["fields", "Lead & customer fields", ["settings.manage"], FieldsTab],
    ["lists", "Sources & rules", ["sources.manage", "settings.manage"], ListsTab],
    ["data", "Demo data & backup", ["settings.manage"], DataTab],
    ["audit", "Audit log", ["audit.view"], AuditTab],
  ].filter(([, , p]) => can(...p));
  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Administration" title="Users & Settings" subtitle="All changes are enforced on the server and recorded in the audit log." />
      <Tabs defaultValue={tabs[0]?.[0]}>
        <TabsList className="bg-white border flex-wrap h-auto">
          {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`settings-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {tabs.map(([k, , , C]) => <TabsContent key={k} value={k} className="pt-4"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
